import React from 'react'

export function FileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      fill="none"
      viewBox="0 0 18 20"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2"
        d="M10.5 7.997l-6 .01"
      />
      <path
        fill="#43D0A3"
        d="M0 2a2 2 0 012-2h9.276a2 2 0 011.28.464L15 2.5l2.28 1.9A2 2 0 0118 5.937V18a2 2 0 01-2 2H2a2 2 0 01-2-2V2z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2"
        d="M13.5 16h-9M13.5 12h-9"
      />
    </svg>
  )
}
